
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"92","height":"92","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"opacity":".2","stroke":"#8F7A61","stroke-width":"5","stroke-miterlimit":"10","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M45.839 46.435H5.577v30.828H45.84V46.435z"}}),_c('path',{attrs:{"d":"M86.1 46.435H45.837v30.828h40.261V46.435zM65.981 15.606H25.72v30.829H65.98V15.606z"}})])])
          )
        }
      }
    